import React from "react";
import styles from "./tooltip.module.scss";

const Tooltip = ({ content, children, placement = "bottom", classes = {}, className = "", width = "max-content", }) => {
  const { tooltip = "", tooltipText = "" } = classes;

  return (
    <span className={[styles.tooltip, styles[`tooltip_${placement}`], tooltip, className].filter(Boolean).join(" ")}>
      {children}

      <span className={`${styles.tooltiptext} ${tooltipText}`} style={{ width }}>{content}</span>
    </span>
  );
};

export default Tooltip;
